export const hasCloudInUrl = (url: string) => {
  return /^(https?:\/\/)?(www.)?(?:[a-zA-Z0-9-]+.)?cloud/.test(url);
};
